export const QA_NAME_DOC_FLOW_EPOST_VALIDATION_PREVIEW_BUTTON =
  'docFlowEpostValidationPreviewButton'
